import { render, staticRenderFns } from "./ItemRecordImgUploader.vue?vue&type=template&id=64294ed2&scoped=true&lang=pug&"
import script from "./ItemRecordImgUploader.vue?vue&type=script&lang=js&"
export * from "./ItemRecordImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./ItemRecordImgUploader.vue?vue&type=style&index=0&id=64294ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64294ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
